module.exports = __webpack_public_path__ + "img/img_tab_4.9f6184d1.png";